export default __webpack_public_path__ + "static/media/iconos-08.0ba82b07.png";